import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import Modal from "react-responsive-modal";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import Comments from "./comments";

class PlayerCommentsModal extends PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);

		this.state = { paused: false };
	}

	onClickClose() {
		if (this.props.onClickClose) {
			this.props.onClickClose();
		}
	}

	// Doing at runtime...could potentially do first time loads up in state
	render() {
		const { userNotesVisible, hasComments } = this.props;
		const additionalProps = {};
		if (!this.props.userNotesVisible) {
			additionalProps.style = { paddingBottom: "16px" };
		}
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const { commentsModal: commentsModalTheme } = theme;

		let label = ""; 
		if (userNotesVisible && hasComments) {
			label = "Comments / User Notes";
		} else if (userNotesVisible) {
			label = "User Notes";
		} else if (hasComments) {
			label = "Comments";
		}

		let additionalPropsContainer = {};
		if (commentsModalTheme && commentsModalTheme.container) {
			additionalPropsContainer.styles = { modal: commentsModalTheme.container };
		}
		

		let modal =
			<Modal classNames={{
				overlay: "ambifi-web-player",
				modal: "player-comments-modal",
				transitionEnter: "ambifi-web-player-modal-slide-up-enter",
				transitionEnterActive: "ambifi-web-player-modal-slide-up-enter-active",
				transitionExit: "ambifi-web-player-modal-slide-up-exit",
				transitionExitActive: "ambifi-web-player-modal-slide-up-exit-active"
			}}
				
				open={this.props.isOpen}
				showCloseIcon={false}
				onEntered={this.onModalEntered}
				onClose={() => { }}
				{...additionalPropsContainer}>
				<div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", alignItems: "center", padding: "16px 30px 16px 30px", boxSizing: "border-box" }}>
					<div {...additionalProps} className="player-comments-modal-title">{label}</div>
					<div style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", marginBottom: "10px", maxHeight:"100%",overflow:"hidden" }}>
						<Comments listIndex={this.props.listIndex} sectionIndex={this.props.sectionIndex} itemIndex={this.props.itemIndex} />
					</div>
					<div className="player-comments-modal-close-button" onClick={this.onClickClose}><FontAwesomeIcon icon="chevron-down" /> GO BACK</div>
				</div>
			</Modal>;

		return modal;
	}
}

PlayerCommentsModal.defaultProps = {
};

export default branch({
	userNotesVisible: ["player", "showCommentsUserNotesVisible"],
	hasComments: ["player", "showCommentsHasComments"]
}, PlayerCommentsModal);